import { CartPage } from '../cartPage';

window.addEventListener('DOMContentLoaded', async () => {
  const cartPage = new CartPage();
  cartPage.setupPage();
});
